export enum CaseSelectControlName {
  CaseUuid = 'caseUuid',
}
